export enum ProductFileEnum {
  "MainProduct" = "MainProduct",
  "Patch" = "Patch",
  "Other" = "Other"
}